/**
 * Handle tab.
 *
 * @param   {Event} e
 * @returns  {Void}
 */
function handleTab(e) {
	e.preventDefault();

	const tabContainer = this.closest('.js-tabs');
	const href = this.getAttribute('href');

	activateTab(tabContainer, href);
}

/**
 * Activate tab.
 *
 * @param {HTMLElement} tabContainer
 * @param {String} href
 */
function activateTab(tabContainer, href) {
	const activeClassName = 'is-active';
	const navLink = tabContainer.querySelector(`.tabs__nav a[href="${href}"]`);
	const navItem = navLink ? navLink.parentElement : null;

	tabContainer.querySelectorAll(`.${activeClassName}`).forEach((el) => el.classList.remove(activeClassName));

	tabContainer.querySelector(`${href}`)?.classList.add(activeClassName);

	navItem?.classList.add(activeClassName);

	const select = tabContainer.querySelector('.tabs__select');
	if (select) {
		select.value = href;
	}
}

/**
 * On select change.
 *
 * @param   {HTMLElement}  container
 * @returns  {Void}
 */
function onSelectChange(e) {
	const container = this.closest('.js-tabs');
	const select = e.currentTarget;
	const val = select.value;

	if (val) {
		activateTab(container, val);
	}
}

/**
 * Initialize tabs.
 */
function initTabs() {
	document.querySelectorAll('.js-tabs').forEach((container) => {
		container.querySelectorAll('.tabs__nav a').forEach((tabTrigger) => {
			tabTrigger.addEventListener('click', handleTab);
		});

		const select = container.querySelector('.tabs__select');
		select?.addEventListener('change', onSelectChange);
	});
}

initTabs();
